import { ConstData } from "./helpers";

export const GRADES: ConstData[] = [
  { title: "Year 3", value: "3" },
  { title: "Year 4", value: "4" },
  { title: "Year 5", value: "5" },
  { title: "Year 6", value: "6" },
  { title: "Year 7", value: "7" },
  { title: "Year 8", value: "8" },
  { title: "Year 9", value: "9" },
  { title: "Year 10", value: "10" },
  { title: "Year 11", value: "11" },
  { title: "Year 12", value: "12" },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/grades.ts